<template>
    <u-chip-outlined-pill v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-chip-outlined-pill>
</template>

<script>
import UChipOutlinedPill from "@/components/publish/styles/chips/u-chip-outlined-pill.vue";

export default {
    props: {},
    components: {
        UChipOutlinedPill,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
